module.exports = __webpack_public_path__ + "static/Michael_Hoffman_headshot_lores-e10ea427f73e28567b53df5671bfdd68.png";